import React from 'react'
import { Text } from '../../../../../../styles/reactnative'
import { useUserInfo } from './useUserInfo'

interface UserInfoDisplayProps {
	userId: number | string
	type: 'loginid' | 'fullname'
}

const UserInfoDisplay: React.FC<UserInfoDisplayProps> = ({ userId, type }) => {
	const { userInfo, loading } = useUserInfo(userId)

	if (loading) {
		return <Text>로딩중...</Text>
	}

	if (!userInfo) {
		return <Text>-</Text>
	}

	if (type === 'loginid') {
		return <Text>{userInfo.loginid || userInfo.email || '-'}</Text>
	}

	if (type === 'fullname') {
		return <Text>{userInfo.fullname || userInfo.nickname || '-'}</Text>
	}

	return <Text>-</Text>
}

export default React.memo(UserInfoDisplay)
